import { createTheme } from "@mui/material/styles";
import "./fonts.css";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#5fcfac",
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
    text: {
      primary: "#212529",
    },
  },
  typography: {
    fontFamily: "'G42 Sans', 'Inter', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

export default theme;
